import { ReactNode, useId } from 'react';

export interface JobContentSectionProps {
  emoji: string;
  title: string;
  children: ReactNode;
}

export function JobContentSection({ emoji, title, children }: JobContentSectionProps) {
  const id = useId();
  return (
    <section className="py-6 gap-4 flex flex-col" aria-labelledby={id}>
      <h3 className="text-large text-neutral-primary2 font-bold" id={id}>
        <span className="mt-1" data-testid="emoji">
          {emoji}
        </span>
        <span>{title}</span>
      </h3>
      {children}
    </section>
  );
}
